/**
 * Complementary products fade transition.
 *
 * Overrides the scroll-based SlideshowComponent inside .complementary-products
 * so slides transition via opacity instead of horizontal scroll.
 * Matches the cart-drawer featured products fade effect.
 *
 * Works by intercepting the slideshow-component after product-recommendations
 * loads its AJAX content, and replacing scroll navigation with aria-hidden toggling.
 */
(function () {
  'use strict';

  function initFadeSlider(slideshowEl) {
    if (!slideshowEl || slideshowEl.dataset.fadeInit) return;
    slideshowEl.dataset.fadeInit = 'true';

    var slider = slideshowEl.querySelector('[id^="Slider-"]');
    var slides = slideshowEl.querySelectorAll('[id^="Slide-"]');

    /* Nav buttons live in .complementary-header (sibling of slideshow-component) */
    var rec = slideshowEl.closest('product-recommendations') || slideshowEl.parentElement;
    var prevBtn = rec.querySelector('.complementary-nav__btn[name="previous"]');
    var nextBtn = rec.querySelector('.complementary-nav__btn[name="next"]');
    var navWrap = rec.querySelector('.complementary-nav');
    var controlLinks = Array.from(slideshowEl.querySelectorAll('.slider-counter__link'));

    if (!slider || slides.length === 0) return;

    var currentPage = 0;
    var totalPages = slides.length;
    var hasMultipleSlides = totalPages > 1;

    /* Show header nav arrows only when there are multiple slides */
    if (navWrap && hasMultipleSlides) navWrap.style.display = '';

    /* Prevent native scroll from interfering */
    slider.style.overflow = 'hidden';

    function update() {
      slides.forEach(function (slide, i) {
        var isActive = i === currentPage;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.setAttribute('tabindex', isActive ? '0' : '-1');

        var links = slide.querySelectorAll('a, button');
        links.forEach(function (el) {
          if (isActive) {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', '-1');
          }
        });
      });

      controlLinks.forEach(function (link, i) {
        link.classList.toggle('slider-counter__link--active', i === currentPage);
        if (i === currentPage) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      if (prevBtn) {
        prevBtn.toggleAttribute('disabled', currentPage === 0);
      }
      if (nextBtn) {
        nextBtn.toggleAttribute('disabled', currentPage >= totalPages - 1);
      }
    }

    if (hasMultipleSlides) {
      /* Override prev/next buttons */
      if (prevBtn) {
        prevBtn.replaceWith(prevBtn.cloneNode(true));
        prevBtn = rec.querySelector('.complementary-nav__btn[name="previous"]');
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (currentPage > 0) {
            currentPage--;
            update();
          }
        });
      }

      if (nextBtn) {
        nextBtn.replaceWith(nextBtn.cloneNode(true));
        nextBtn = rec.querySelector('.complementary-nav__btn[name="next"]');
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (currentPage < totalPages - 1) {
            currentPage++;
            update();
          }
        });
      }

      /* Override dot/number pagination */
      controlLinks.forEach(function (link, index) {
        var newLink = link.cloneNode(true);
        link.replaceWith(newLink);
        newLink.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          currentPage = index;
          update();
        });
      });
      /* Refresh reference after cloning */
      controlLinks = Array.from(slideshowEl.querySelectorAll('.slider-counter__link'));

      /* Prevent scroll-based updates from SlideshowComponent */
      slider.addEventListener('scroll', function () {
        slider.scrollLeft = 0;
      });

      /* Disable SlideshowComponent's prev/next disabled-state logic
         by removing the original slider scroll listener */
      slider.style.scrollSnapType = 'none';
      slider.style.scrollBehavior = 'auto';
    }

    /* Set initial state — always run to ensure first slide is active & clickable */
    update();
  }

  /**
   * Observe product-recommendations.complementary-products for content changes.
   * When loadRecommendations injects new innerHTML, we initialise the fade slider.
   */
  function observeRecommendations() {
    var containers = document.querySelectorAll('product-recommendations.complementary-products');
    containers.forEach(function (rec) {
      var observer = new MutationObserver(function () {
        var slideshow = rec.querySelector('slideshow-component');
        if (slideshow) {
          initFadeSlider(slideshow);
        }
      });
      observer.observe(rec, { childList: true, subtree: true });

      /* Also check if already loaded */
      var existing = rec.querySelector('slideshow-component');
      if (existing) {
        initFadeSlider(existing);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeRecommendations);
  } else {
    observeRecommendations();
  }

  /* --- Add to cart from complementary card --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.complementary-card__add[data-variant-id]');
    if (!btn) return;

    var variantId = btn.getAttribute('data-variant-id');
    btn.disabled = true;
    btn.classList.add('loading');

    var body = JSON.stringify({
      items: [{ id: parseInt(variantId), quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'complementary-products',
            productVariantId: variantId,
            cartData: data,
          });
        }
        btn.disabled = false;
        btn.classList.remove('loading');
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('loading');
      });
  });
})();
